module.exports = __webpack_public_path__ + "img/images3.d97d6187.jpg";